import {MessageDescriptor} from '@lingui/core';
import {t} from '@lingui/macro';

/*
 * Types.
 */

export enum ExpressionsEditorBaseErrorsEnum {
  INVALID_ATOM = 'INVALID_ATOM',
  UNRESOLVED_REF = 'UNRESOLVED_REF',
  UNRESOLVED_STRING_TEMPLATE = 'UNRESOLVED_STRING_TEMPLATE',
}

/*
 * Constants.
 */

export const expressionsEditorBaseErrorLabels: Record<ExpressionsEditorBaseErrorsEnum, MessageDescriptor> = {
  [ExpressionsEditorBaseErrorsEnum.INVALID_ATOM]: t(
    'rule-editor-card-error-invalid-atom',
  )`One of your rule variables is invalid`,
  [ExpressionsEditorBaseErrorsEnum.UNRESOLVED_REF]: t(
    'rule-editor-card-error-missing-expression-reference',
  )`Missing dynamic variable`,
  [ExpressionsEditorBaseErrorsEnum.UNRESOLVED_STRING_TEMPLATE]: t(
    'rule-editor-card-error-missing-string-template',
  )`Missing string variable`,
};
